export default "__VITE_ASSET__282d32cf__"